import {Component, Inject, OnInit} from '@angular/core';
import {ImageCroppedEvent, ImageTransform} from "ngx-image-cropper";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ToastService} from "ng-zorro-antd-mobile";
import imageCompression from "browser-image-compression";

@Component({
  selector: 'yz-img-cropper',
  templateUrl: './yz-img-cropper.component.html',
  styleUrls: ['./yz-img-cropper.component.less']
})
export class YzImgCropperComponent implements OnInit {

  cropperStyle = {
    height: window.innerHeight - 142 + 'px',
    width: '100%',
    padding: 0,
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'align-content': 'center',
    'flex-wrap': 'wrap'
  };

  imageChangedEvent: any = null;
  imageBase64: string = null;
  imageBlobFile: Blob = null;

  croppedImage: any = null;
  showImg: boolean = false;
  imgInfo = {
    width: 0,
    height: 0
  };

  canvasRotation = 0;
  transform: ImageTransform = {};
  scale = 1;

  // 图片压缩进度
  percent = 0;

  constructor(public dialogRef: MatDialogRef<YzImgCropperComponent>,
              private _toast: ToastService,
              @Inject(MAT_DIALOG_DATA) public data: ComponentOption) {
  }

  ngOnInit() {
    if (this.data.imgFile) {
      this.fileChangeEvent(this.data.imgFile);
    } else {
      this._toast.info('请选择上传图片！');
    }
  }

  fileChangeEvent(event: any): void {
    if (this.data.fileType == 'FileEvent' || !this.data.fileType) {
      this.imageChangedEvent = event;
      this.imageBase64 = null;
      this.imageBlobFile = null;
    } else if (this.data.fileType == 'Base64') {
      this.imageChangedEvent = null;
      this.imageBase64 = event;
      this.imageBlobFile = null;
    } else if (this.data.fileType == 'BlobFile') {
      this.imageChangedEvent = null;
      this.imageBase64 = null;
      this.imageBlobFile = event;
    }
  }

  // 每次裁剪图像时发出
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.imgInfo = event;
  }

  // 选择错误的文件类型时发出（仅允许png、gif和jpg）
  loadImageFailed() {
    this._toast.info(`图片选择失败！`);
  }


  // 还原图片大小
  resetImage() {
    this.scale = 1;
    this.canvasRotation = 0;
    this.transform = {};
  }


  // 取消裁剪
  cancelCropper() {
    this.imageChangedEvent = null;
    this.imageBase64 = null;
    this.imageBlobFile = null;

    this.croppedImage = null;
    this.showImg = false;
    this.percent = 0;
    this.imgInfo = {
      width: 0,
      height: 0
    };
    this.dialogRef.close();
    this.resetImage();
  }

  // 裁剪完毕=>压缩图片
  confirmCropper() {
    if(!this.croppedImage) return;
    this.dataURLtoFile(this.croppedImage, 'img_name');
  }

  dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file = new File([u8arr], filename, {type: mime});
    this.compressImage(file);
  }

  // 图片压缩 https://www.npmjs.com/package/browser-image-compression
  async compressImage(imageFile) {
    const options = {
      maxSizeMB: this.data.maxSizeMB,
      maxWidthOrHeight: this.data.maxWidthOrHeight,
      fileType: `image/${this.data.format}`,
      useWebWorker: true,
      onProgress: (res) => {
        this.percent = res;
      }
    };
    try {
      const compressedFile = await imageCompression(imageFile, options);
      this.blobToBase64(compressedFile, (dataurl) => {
        this.dialogRef.close(dataurl);
      });
      this.cancelCropper();
    } catch (error) {
      console.error('图片压缩失败！');
    }
  }

  blobToBase64(blob, callback) {
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      callback(e.target['result']);
    };
    fileReader.readAsDataURL(blob);
  }
}

// 组件参数
export class ComponentOption {
  imgFile: any; // 上传的图片文件
  fileType?: string = 'FileEvent'; // 上传的图片文件类型 'FileEvent' | 'Base64' | 'BlobFile'
  containWithinAspectRatio?: boolean = false; // 设置为true时，将在图像周围添加填充以使其适合纵横比,默认false
  format?: string = 'png'; // 输出格式（png、jpeg、webp、bmp、ico）（并非所有浏览器都支持所有类型，始终支持png，其他为可选），默认png
  imageQuality?: number = 92; // 这仅适用于使用jpeg或webp作为输出格式时。输入介于0和100之间的数字将决定输出图像的质量，默认92。
  aspectRatio?: number = 1 / 1; // 图片宽度/高度比（例如，正方形为1/1，4/3，16/9…），默认1/1
  maxSizeMB?: number = 1; // 裁剪压缩后的图片大小的最大值，默认1MB
  maxWidthOrHeight?: number = 100; // 裁剪压缩后的图片的最大宽度或高度，默认100
}
